import { render } from "./CarouselCards.vue?vue&type=template&id=17502829"
import script from "./CarouselCards.vue?vue&type=script&lang=js"
export * from "./CarouselCards.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__